<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Change count" :caret="true" theme="filter" :icon="($isMobile) ? 'users' : false" :iconLeft="$isMobile" class="input-button"><b>{{ text }}</b></core-button>
	
	<core-dropdown-list :expanded="is.expanded" align="right" title="Count" theme="filter" :caret="true" v-propagation v-on:close="is.expanded = false">

		<core-dropdown-item v-for="item in options" v-bind:key="item.key" v-on:click.native="onOptionClick(item.key)" v-bind:class="{'is-active': value === item.key}">

			{{ item.text }}

		</core-dropdown-item>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	components: {
		
	},

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'page',
		'filter'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		options: function() {

			var options = []

			options.push({
				key: 0,
				text: 'Any count'
			})

			if (this.$route.name === 'InsightsPlays') {

				options.push({
					key: 1,
					text: '1 player'
				})
				
			}

			options.push({
				key: 2,
				text: '2 players'
			})

			options.push({
				key: 3,
				text: '3 players'
			})

			options.push({
				key: 4,
				text: '4 players'
			})

			options.push({
				key: 5,
				text: '5 players'
			})

			options.push({
				key: 6,
				text: '6+ players'
			})

			return options

		},

		value: function() {

			return this.$store.getters['filter/insights/' + this.filter + '/players']

		},

		text: function() {

			return this.options[(this.value) ? this.value - 1 : this.value].text

		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onOptionClick: function(value) {

			this.$store.commit('filter/insights/' + this.filter + '/players', value)

		}

	}

}

</script>

<style scoped>

</style>
